import React, { FunctionComponent } from 'react';
import { useTranslation } from '@rbx/intl';
import { Alert, Typography } from '@rbx/ui';
import RiskLevel from '@modules/openCloud/swagger/types/RiskLevel';
import useOperation from '../../hooks/useOperation';

const getRiskLevelSeverity = (riskLevel: RiskLevel) => {
  switch (riskLevel) {
    case RiskLevel.LOW:
      return 'info';
    case RiskLevel.MEDIUM:
      return 'warning';
    case RiskLevel.HIGH:
    default:
      return 'error';
  }
};

const getRiskLevelMessage = (riskLevel: RiskLevel, translate: (key: string) => string): string => {
  switch (riskLevel) {
    case RiskLevel.LOW:
      return translate('Description.TryItOutLowRisk');
    case RiskLevel.MEDIUM:
      return translate('Description.TryItOutMediumRisk');
    case RiskLevel.HIGH:
    default:
      return translate('Description.TryItOutHighRisk');
  }
};

const RiskLevelAlert: FunctionComponent = () => {
  const { translate } = useTranslation();
  const { riskLevel } = useOperation();

  return (
    <Alert severity={getRiskLevelSeverity(riskLevel)}>
      <Typography variant='body2' component='div'>
        {getRiskLevelMessage(riskLevel, translate)}
      </Typography>
      <Typography variant='body2' component='div'>
        {translate('Description.TryItOutSecurityReminder')}
      </Typography>
    </Alert>
  );
};

export default RiskLevelAlert;
